<template>
    <div class="container">
        <div class="row">
            <div class="col text-center">
                <preloader />
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Preloader from "../common/preloader.vue";

    export default {
        components: {Preloader},
        name: 'AuthRedirect',

        data: function(){
            return {
                authKey: "",
                error: null
            }
        },

        mounted(){
            this.$authService.tryLoginByCode(this.$route.query.code)
                .then(() => {
                  this.$router.push('/');
                });
        }
    }
</script>

<style scoped>
    .card{
        width: 400px;
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/auth/authRedirect.component.vue